module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1094.ef47a66f.png";